import React from 'react'
import {Alert} from 'antd'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import {useLazyQuery, useMutation} from '@apollo/react-hooks'

import UpsellView from 'components/shared/UpsellView'

const addUpsellOrderMutation = gql`
  mutation AddUpsellOrder($input: AddUpsellOrderInput!) {
    AddUpsellOrder(input: $input) {
      order {
        id
      }
    }
  }
`

export const previewOrderBillQuery = gql`
  query PreviewOrderBillQuery($bookingId: ID!, $products: [String]) {
    booking(id: $bookingId) {
      id
      previewOrderBill(products: $products) {
        sumIncVat
      }
    }
  }
`
function createAvailableProductsList(availableProducts = []) {
  let products = []
  availableProducts.forEach(availableProduct => {
    switch (availableProduct.__typename) {
      case 'StylingProduct':
        products.push({
          ...availableProduct,
          name: 'Ekstra time',
          extraHour: true,
        })
        break

      case 'FloorPlansProduct':
        products.push({
          ...availableProduct,
          measurement: true,
          unlimited: true,
          floors: 1,
        })
        break

      default:
        const toMerge = {}
        if (availableProduct.minQuantity) {
          toMerge.quantity = availableProduct.minQuantity
        }
        products.push({
          ...availableProduct,
          ...toMerge,
        })
    }
  })

  return products
}

const Upsell = ({booking}) => {
  const availableProducts = booking.availableProducts.edges.map(({node}) => node)
  const products = createAvailableProductsList(availableProducts)

  const [previewQuery, {loading, data: previewData = {}}] = useLazyQuery(previewOrderBillQuery)
  const [mutation, {loading: isSubmitting, data: mutationData, error}] = useMutation(addUpsellOrderMutation)

  if (!products.length) {
    return null
  }

  if (mutationData) {
    return (
      <div className="section receipt">
        <Alert
          type="success"
          message="Mersalget er registrert! Bildene kan lastes opp på leveransesiden."
        />
      </div>
    )
  }
  if (error) {
    return (
      <div className="section error">
        <Alert
          type="error"
          message="En feil oppstod ved opprettelse av ordren. Vennligst forsøk på nytt eller kontakt EFKT kundeservice."
        />
      </div>
    )
  }

  function previewOrderBill(products = []) {
    if (!booking.customerSpecificPriceListUrl) {
      return previewQuery({variables: {bookingId: booking.id, products}})
    }
  }

  function addUpsellOrder(products, approval) {
    return mutation({
      variables: {
        input: {
          bookingId: booking.id,
          products,
          approval,
        },
      },
    })
  }

  return (
    <UpsellView
      customerSpecificPriceListUrl={booking.customerSpecificPriceListUrl}
      brokerPhone={booking.estate.broker.phone}
      products={products}
      previewOrderBill={previewData.booking ? previewData.booking.previewOrderBill : {}}
      fetchPreviewOrderBill={previewOrderBill}
      loading={loading}
      addUpsellOrder={addUpsellOrder}
      isSubmitting={isSubmitting}
    />
  )
}

Upsell.propTypes = {
  booking: PropTypes.object.isRequired,
}

export default Upsell
